import styled from 'styled-components';
import { BACKGROUND_TO_DO_LIST } from '../../config/media';

const Wrapper = styled.div`
       display: flex;
    .dashboard-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-top: 2rem;
        margin: 0px auto;
        max-width: 100rem;
        width: 60vw;
        position: relative;
    }

    .pl-5 {
        padding-left:5px;
    }
    
    .pop-up-content .container {
        align-items: center;
    }
    .container {
        display: flex;
        width: 70%;
        margin-bottom: 20px;
    }
    .wrapper-container {
        display: flex;
        flex-direction: column;
        padding: 30px;
        background-color: #29292C;
        background-repeat: no-repeat;
        background-position: right 0;
        .header-container {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            .text-content {
                color: #ffffff;
                font-weight: bold;
                margin-left: 10px;
                font-size: 16px;
            }
        }
        .mb-2 {
            margin-bottom: 15px;
        }
        .link-content {
            color: #3A4FFF;
            text-decoration: underline;
        }
    }
    .content-wrapper-1 {
        margin-right: 1rem;
        width: 50%;
        position: relative;
        word-break: break-word;
        background-color: #29292C;
    }
    .content-wrapper-2 {
        width: 50%;
        position: relative;
        word-break: break-word;
        color: #ffffff;
        background-color: #29292C;
        background-image: url(${BACKGROUND_TO_DO_LIST});
        background-repeat: no-repeat;
        background-position: right 0;
    }
    .content-border {
        position: absolute;
        width: 100%;
        border-top: 5px solid #A8A8B1;
        animation: progress 700ms ease-in-out;
    }

    @keyframes progress {
            0% {
                width: 0;
                opacity: 1;
            }
            100% {
                width: 100%;
                opacity: 1;
            }
    }
    .todoAnime {
        animation: fadeMe 1500ms ease-in-out 0.5s;
    }
    .todoAnime1 {
        animation: fadeMe-1 1500ms ease-in-out 1s;
    }
    .todoAnime2 {
        animation: fadeMe-2 1500ms ease-in-out 1.5s;
    }
    .todoAnime3 {
        animation: fadeMe-3 1500ms ease-in-out 2s;
    }
    .todoAnime4 {
        animation: fadeMe-4 1500ms ease-in-out 2.5s;
    }
    .todoAnime5 {
        animation: fadeMe-5 1500ms ease-in-out 2.5s;
    }
    .todoAnime6 {
        animation: fadeMe-6 1500ms ease-in-out 2.5s;
    }
    
    @keyframes fadeMe {
        0% {
                opacity: 0.4;
        }
        100% {
                opacity: 1;
        }
    }
    @keyframes fadeMe-1 {
        0% {
                opacity: 0.4;
        }
        100% {
                opacity: 1;
        }
    }
    @keyframes fadeMe-2 {
        0% {
                opacity: 0.4;
        }
        100% {
                opacity: 1;
        }
    }
    @keyframes fadeMe-3 {
        0% {
                opacity: 0.4;
        }
        100% {
                opacity: 1;
        }
    }
    @keyframes fadeMe-4 {
        0% {
                opacity: 0.4;
        }
        100% {
                opacity: 1;
        }
    }
    
    .exchange-logo {
        margin-right: 0.5rem;
        width: 5rem;
    }
    .flex-content {
        display: flex;
        color: #ffffff;
    }
    .full-width {
        flex: 1;
    }
    .details-menu {
        font-weight: 500;
        margin-right: 0.25rem;
        color: #ffffff;
        a {
            color: #3A4FFF;
    }
    }
    .details-icon {
        width: 1.2rem;
        margin-right: 0.25rem;
    }
    .requirement-icon {
        width: 0.75rem;
        // margin-right: 0.25rem;
    }
    .warn-icon {
        color: #F83E18;
    }
    .volume-details-wrapper {
    }
    .fees-container {
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;
    }
    .view-details {
        text-align: end;
    }
    .block-ui-container {
        position: relative;
        width: 100%;
        .block-ui-message {
            display: none;
        }
    }
    .blocked-ui {
        text-shadow: 0 0 5px #000000 !important;
        color: transparent !important;
        .title,
        .details-menu {
            text-shadow: 0 0 5px #000000 !important;
            color: transparent !important;
        }
        &:hover {
            .block-ui-message {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: 100%;
                top: 8rem;
                z-index: 999;
    
                .message-icon {
                    height: 7rem;
                    width: 7rem;
                }
                .message-text {
                    font-size: 18px;
                    font-weight: bold;
                    margin: 1rem 0rem;
                    color: #000000;
                    text-shadow: 0 0 black;
                }
            }
        }
        &::before {
            background-color: #FFFFFF;
            border: 2px solid cyan;
            content: '';
            height: 100%;
            left: 0px;
            opacity: 0.9;
            position: absolute;
            top: 0px;
            width: 100%;
            z-index: 999;
        }
    }
  
    @media (max-width: 1200px) {
        width: 95%;
    }
    
	@media (max-width: 960px) {
        .container {
            flex-direction: column;
            .content-wrapper-1,
            .content-wrapper-2 {
                width: 100%;
                margin-bottom:10px
            }
            .table-wrapper {
                overflow-x: scroll;
            }
        }
	}
    @media (max-width: 1400px) {
    .container {
        display: flex;
        width: 100%;
    }
    .wrapper-container {
            padding: 25px;
        }
    }
    @media (max-width:425px) {
        .flex-content {
            display: flex;
            flex-direction: column;
            .img-container {
                display: flex;
                justify-content:center;
            }
        }
        .wrapper-container {
            .header-container {
                flex-direction:column;
                .text-content {
                    font-size:14px;
                    margin-left:0px;
                    width: 100%;
                    margin-top: 0.5rem;
                }
            }
        }
    }
`;

export const ProgressContainer = styled.div`
    .progress-container {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
    }
    .progress-bar {
        display: flex;
        height: 10px;
        margin-top: 5px;
        .barA {
            background-color: #288500;
            margin-right: 2px;
            width: ${(props) => props.percentA};
        }
        .barB {
            background-color: #F24141;
            width: ${(props) => props.percentB};
        }
    }
`;

export const BlockContainer = styled.div`
    padding: 0px 0.5rem;
    width: 100%;
    padding: 10px 30px 30px 30px;
    .title-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 0.5rem;
    }
    .title {
        font-weight: 700;
        font-size: 24px;
        margin-bottom: 0.25rem;
        font-family: HaasGrotDisp;
    }
    .clickable-link {
        color: #5985ff;
        cursor: pointer;
        text-decoration: underline;
    }
    .clickable-link:hover {
        color: #3A4FFF;
        text-decoration: none;
    }
	@media (max-width: 960px) {
        .title-wrapper {
            flex-direction: column;
        }
    }
	@media (max-width: 1400px) {
        padding: 5px 20px 20px 20px;
       
    }
`;

export const FilterContent = styled.div`
    display: flex;
`;

export default Wrapper;
